import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import { OverflowContextProvider } from 'modules/core/lib/overflowContext'

interface Props {
  id: number
  title: string
}

const HeaderCell = ({ id, title }: Props) => {
  const ref = React.useRef(null)

  return (
    <Table.HeadCell key={id}>
      <Box maxWidth="s120">
        <OverflowContextProvider childrenRef={ref} value={title}>
          <Text.Normal weight="semibold" color="grey800" size="200" innerRef={ref} ellipsis>
            {title}
          </Text.Normal>
        </OverflowContextProvider>
      </Box>
    </Table.HeadCell>
  )
}

export default HeaderCell
